import { render, staticRenderFns } from "./VehicleStatusCard.vue?vue&type=template&id=74b20804&"
import script from "./VehicleStatusCard.vue?vue&type=script&lang=js&"
export * from "./VehicleStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./VehicleStatusCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports